import { Component, EventEmitter, Input, Output } from '@angular/core';

//* Core
import { Check } from '@core/models';

@Component({
  selector: 'sp-dashboard-dropdown',
  template: `
    <div class="dropdown" *ngIf="paystubs.length > 1">
      <p>Paystub {{ selectedDropdownItemIndex }}/{{ paystubs.length }} &nbsp;&nbsp;</p>
      <i class="far fa-chevron-down fa-sm"></i>
      <ul class="dropdown-nav">
        <li
          [ngClass]="dropdownItemsClass[i]"
          *ngFor="let paystub of paystubs; let i = index"
          [value]="paystub.checkId"
          (click)="selectDropdownItem(paystub.checkId, i)">
          <p>Paystub {{ i + 1 }}</p>
          <p>{{ paystub.amount }}</p>
        </li>
      </ul>
    </div>

    <!-- <div *ngIf="paystubs.length > 1 && isTouch()" class="dropdown-select">
      <select (change)="selectItemEvent.emit($event.target.value)">
        <option *ngFor="let paystub of paystubs; let i = index" [value]="paystub.checkId">
          Paystub {{ i + 1 }} {{ paystub.amount }}
        </option>
      </select>
    </div> -->
  `,
  styleUrls: ['dashboard-dropdown.scss'],
})
export class DashboardDropdownComponent {
  @Input() paystubs: Check[];
  @Output() selectItemEvent = new EventEmitter<string>();

  // initialize first dropdown item as selected
  selectedDropdownItemIndex = 1;

  // the array for holding css classes for dropdown
  dropdownItemsClass: string[] = [];

  // ngOnInit() {
  // Initialize all items of dropdown with unselected class
  // this.dropdownItemsClass = this.paystubs.map(paystub => 'dropdown-unselected');
  // set dropdown's first item's class as selected
  // this.dropdownItemsClass[0] = 'dropdown-selected';
  // }

  selectDropdownItem(checkId: string, index: number) {
    // reset  previously selected dropdown item's class as unslected
    // this.dropdownItemsClass[this.selectedDropdownItemIndex - 1] = 'dropdown-unselected';

    // reset selected item index with new selected item
    this.selectedDropdownItemIndex = index + 1;

    // set dropdown's selected item's class as selected
    // this.dropdownItemsClass[index] = 'dropdown-selected';

    // this fired event is refired from DashboardDetailsComponent and ultimately
    // handled by DashboardComponent changePaystub to load the new selected paystub
    this.selectItemEvent.emit(checkId);
  }

  // isTouch = () => {
  //   const ua = navigator.userAgent;
  //   if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
  //     return true;
  //   }
  //   if (
  //     /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
  //       ua
  //     )
  //   ) {
  //     return true;
  //   }
  //   return false;
  // };
}
